require('../core');

angular.module('ui-ng-notification').factory('phxNotificationMessageStatusEnum', function (Enumeration) {
  return Enumeration('phxNotificationMessageStatusEnum', {
    INFO: {
      cssClass: 'type-info',
      messageSettings: {
        iconClass: 'icon type-checkmark',
        dismissButton: false,
        dismissOnTimeout: true,
        dismissOnClick: true
      }
    },
    SUCCESS: {
      cssClass: 'type-success',
      messageSettings: {
        iconClass: 'icon type-checkmark',
        dismissButton: false,
        dismissOnTimeout: true,
        dismissOnClick: true
      }
    },
    WARN: {
      cssClass: 'type-warning',
      messageSettings: {
        iconClass: 'icon type-caution',
        dismissOnTimeout: true,
        dismissButton: true,
        dismissOnClick: true
      }
    },
    ERROR: {
      cssClass: 'type-error',
      messageSettings: {
        iconClass: 'icon type-caution',
        dismissOnTimeout: false,
        dismissButton: false,
        dismissOnClick: true
      }
    }
  })
});



// WEBPACK FOOTER //
// notification_message_status_enum.js